import React from "react";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalFooter, ModalHeader } from "components/Modal";
import SubmitButton from "components/SubmitButton";
import Typeahead from "components/Typeahead";
import UserTag from "components/UserTag";
import Translate from "utils/translate";

import styles from "./ShareStatusModal.css";

const { t } = new Translate("EnquiryHeader");

export class ShareStatusModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
      sharedBrokers: this.props.sharedBrokers,
    };

    this.handleAddBroker = this.handleAddBroker.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirmClose = this.handleConfirmClose.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleRemoveBroker = this.handleRemoveBroker.bind(this);
  }

  handleAddBroker(broker) {
    this.setState({
      input: "",
      sharedBrokers: [...this.state.sharedBrokers, broker],
    });
  }

  handleClose() {
    this.setState({ input: "", sharedBrokers: this.props.sharedBrokers });
    this.props.onClose();
  }

  handleConfirmClose() {
    if (confirm(t("confirm.cancel"))) {
      // eslint-disable-line
      this.handleClose();
    }
  }

  handleInput(input) {
    this.setState({ input });
  }

  handleRemoveBroker(index) {
    this.setState({
      sharedBrokers: [
        ...this.state.sharedBrokers.slice(0, index),
        ...this.state.sharedBrokers.slice(index + 1),
      ],
    });
  }

  render() {
    const { assets, creator, isLoading, isOpen, onSave, portfolioID } = this.props;

    const { input, sharedBrokers } = this.state;

    const searchParameters = {
      page: 0,
      hitsPerPage: 20,
      facets: "broker_asset_ids, portfolio_ids",
      filters:
        assets.length && !!assets[0]
          ? `broker_asset_ids:${assets.map((a) => a.id).join(",")}`
          : `broker_portfolio_ids:${portfolioID}`,
    };

    return (
      <Modal isOpen={isOpen} margin={8} onClose={this.handleConfirmClose} width={530}>
        <ModalHeader onClose={this.handleClose}>{t("modal.header")}</ModalHeader>
        <ModalBody>
          <h3>{t("modal.title")}</h3>
          <p>{t("modal.info")}</p>
          <br />
          <div className={styles.brokers}>
            {sharedBrokers.map((broker, index) => (
              <div className={styles.broker} key={index}>
                <UserTag
                  deleteDisabled={broker.id === creator.id}
                  onDelete={() => this.handleRemoveBroker(index)}
                  user={broker}
                />
              </div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter>
          <div className={styles.footer}>
            <div className={styles.left}>
              <fieldset>
                <Typeahead
                  onInput={this.handleInput}
                  onSelect={this.handleAddBroker}
                  placeholder={t("modal.search_collaborators")}
                  searchIndex="Broker_by_name_email"
                  searchParameters={searchParameters}
                  sublabelKey="company.name"
                  value={input}
                />
              </fieldset>
            </div>
            <div className={styles.right}>
              <SubmitButton
                isSubmitting={isLoading}
                onSubmit={() => onSave(sharedBrokers)}
                submitLabel={t("modal.save")}
              />
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

ShareStatusModal.propTypes = {
  assets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired
  ).isRequired,
  creator: PropTypes.shape({
    id: PropTypes.number.isRequired,
    company: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  }).isRequired,
  portfolioID: PropTypes.number,
  sharedBrokers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      fname: PropTypes.string,
      lname: PropTypes.string,
      profilePictureUrl: PropTypes.url,
      title: PropTypes.string,
      company: PropTypes.shape({
        name: PropTypes.string,
      }),
    })
  ),
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default ShareStatusModal;
